<template>
  <v-list :dense="dense" class="layout-drawer">
    <div
      class="layout-drawer-item"
      v-for="item in routes.filter((item) => item.meta && !item.meta.hidden)"
      :key="item.title"
    >
      <template v-if="isVisibleItem(item)">
        <v-list-item :to="resolvePath(onlyOneChild.path)" ripple="ripple" v-if="checkPermission(onlyOneChild)">
          <template v-slot="{ active }">
            <v-list-item-icon
              class="layout-drawer__icon"
              v-if="hasOneVisibleChild(item.children, item)"
            >
              <v-icon v-if="onlyOneChild.meta.icon">
                {{ getListIcon(onlyOneChild) }}
              </v-icon>
              <img
                v-if="onlyOneChild.meta.img && !active"
                :src="require(`../../assets/img/menu/${onlyOneChild.meta.img}`)"
              />
              <img
                v-if="onlyOneChild.meta.img && active"
                :src="
                  require(`../../assets/img/menu/white/${onlyOneChild.meta.img}`)
                "
              />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-if="navbarShow">
                {{ getListTitle(onlyOneChild) }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </template>

      <template v-else>
        <v-list-group v-if="navbarShow" :group="resolvePath(item.path)">
          <template #appendIcon>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-icon class="layout-drawer__icon">
              <img v-if="item.meta.img" :src="require(`../../assets/img/menu/${item.meta.img}`)" />
              <v-icon class="bigger" v-if="item.meta.icon">
                {{ getListIcon(item) }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ getListTitle(item) }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <the-layout-drawer-list
            :style="{ 'margin-left': '40px' }"
            :dense="dense"
            :routes="item.children"
            :base-path="resolvePath(item.path)"
          />
        </v-list-group>

        <v-menu bottom right v-else open-on-hover offset-x rounded="xl">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              ripple="ripple"
              v-bind="attrs"
              v-on="on"
              :input-value="$route.path.indexOf(item.path) !== -1"
            >
              <template v-slot="{ active }">
                <v-list-item-icon v-if="item.meta.img" class="layout-drawer__icon">
                  <img
                    v-if="active"
                    :src="
                      require(`../../assets/img/menu/white/${item.meta.img}`)
                    "
                  />
                  <img
                    v-else
                    :src="require(`../../assets/img/menu/${item.meta.img}`)"
                  />
                </v-list-item-icon>
                <v-list-item-icon  v-if="item.meta.icon" class="layout-drawer__icon">
                  <v-icon class="bigger" >
                    {{ getListIcon(item) }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="navbarShow">
                  <v-list-item-title>
                    {{ getListTitle(item) }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </template>

          <v-list>
            <v-list-item
              v-for="(child, i) in item.children.filter(
                (childItem) => childItem.meta && !childItem.meta.hidden && checkPermission(childItem)
              )"
              :key="i"
              :to="resolvePath(`${item.path}/${child.path}`)"
            >
              <v-list-item-title style="color: #027975">{{ getListTitle(child) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>
  </v-list>
</template>

<script>
import { resolve } from "path";
import { mapGetters } from "vuex";

export default {
  name: "TheLayoutDrawerList",
  props: {
    dense: Boolean,
    iconShow: Boolean,
    isNest: Boolean,
    routes: {
      type: Array,
      default: () => {},
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  computed: {
    ...mapGetters(["navbarShow", "permissions"]),
  },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path);
    },
    checkPermission(item) {
      const permissions = [...this.permissions];
      if (!item.meta || !item.meta.context || this.lodash.isEmpty(permissions)) {
        return true;
      }
      const filteredPermissions = this.lodash.filter(permissions, p => item.meta.context.includes(p.code));
      if (this.lodash.isEmpty(filteredPermissions)) {
        return false;
      }
      return filteredPermissions.filter(val => val.action.includes("read")).length > 0;
    },
    isVisibleItem(item) {
      return (
        this.hasOneVisibleChild(item.children, item) &&
        (!this.onlyOneChild.children || this.onlyOneChild.noVisibleChildren) &&
        !item.meta.alwaysShow
      );
    },
    hasOneVisibleChild(children = [], parent) {
      const visibleChildren = children.filter((item) => {
        if (item.meta && item.meta.hidden) return false;
        // Temp set(will be used if only has one visible child)
        this.onlyOneChild = item;
        return true;
      });

      // When there is only one child router, the child router is displayed by default
      if (visibleChildren.length === 1) {
        if (!parent.meta.alwaysShow) {
          this.onlyOneChild.path = resolve(parent.path, this.onlyOneChild.path);
        }
        this.onlyOneChild.meta.icon =
          this.onlyOneChild.meta.icon || (parent.meta || {}).icon || "";

        return true;
      }

      // Show parent if there are no child router to display
      if (visibleChildren.length === 0) {
        this.onlyOneChild = { ...parent, noVisibleChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(path) {
      if (this.isExternal(path)) {
        return path;
      }
      return resolve(this.basePath, path);
    },
    getListIcon(item) {
      return this.iconShow && item.meta ? item.meta.icon : " ";
    },
    getListTitle(item) {
      return item.meta ? this.$t(item.meta.title) : "";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep
  .layout-drawer-item
  > .v-list-item--active.v-list-item {
  background: #42d69e 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #0000000d;
  border-radius: 10px;
  opacity: 1;
  color: #ffffff;
}

.v-list-group--active
  > .v-list-group__header
  > .v-list-group__header__append-icon
  .v-icon {
  transform: rotate(90deg);
}
.bigger{
  zoom: 1.2;
}
.layout-drawer {
  padding: 0;
  .layout-drawer-item {
    margin-bottom: 12px;
  }
}
.menu-static.menu-left .v-list-item__icon.layout-drawer__icon {
  height: 40px !important;
  padding: 8px 10px;
  margin: 0 !important;
  max-width: 44px;
}
</style>
